import type { Step } from '@/components/wizard/Step';

import type { AddCatalogWizardState } from './addCatalogWizardState';
import { CatalogBiglakeConfigStep } from './steps/CatalogBiglakeConfigStep';
import { CatalogConnectorTypeStep } from './steps/CatalogConnectorTypeStep';
import { CatalogIcebergConfigStep } from './steps/CatalogIcebergConfigStep';
import { CatalogReviewStep } from './steps/CatalogReviewStep';
import { CatalogSelectRegionStep } from './steps/CatalogSelectRegionStep';
import { InlineAddConnectorStep } from './steps/InlineAddConnectorStep';
import { InlineAddGcpConnectorStep } from './steps/InlineAddGcpConnectorStep';

const glueReview: Step<AddCatalogWizardState> = {
  id: 'catalog_review',
  Component: CatalogReviewStep,
};

const biglakeReview: Step<AddCatalogWizardState> = {
  id: 'biglake_review',
  Component: CatalogReviewStep,
};

const selectRegionThenReview: Step<AddCatalogWizardState> = {
  id: 'select_region',
  Component: CatalogSelectRegionStep,
  next: [glueReview],
};

const biglakeConfigThenReview: Step<AddCatalogWizardState> = {
  id: 'biglake_config',
  Component: CatalogBiglakeConfigStep,
  next: [biglakeReview],
};

const icebergReview: Step<AddCatalogWizardState> = {
  id: 'iceberg_review',
  Component: CatalogReviewStep,
};

const icebergConfigThenReview: Step<AddCatalogWizardState> = {
  id: 'iceberg_config',
  Component: CatalogIcebergConfigStep,
  next: [icebergReview],
};

export const AddCatalogFlow: Step<AddCatalogWizardState> = {
  id: 'select_connector',
  Component: CatalogConnectorTypeStep,
  next: [
    // next[0]: existing connector (Glue) → select region → review
    selectRegionThenReview,
    // next[1]: new AWS connector → create connector → select region → review
    {
      id: 'inline_add_connector',
      Component: InlineAddConnectorStep,
      nonReturnable: true,
      next: [selectRegionThenReview],
    },
    // next[2]: new GCP connector → create connector → biglake config → review
    {
      id: 'inline_add_gcp_connector',
      Component: InlineAddGcpConnectorStep,
      nonReturnable: true,
      next: [biglakeConfigThenReview],
    },
    // next[3]: existing connector (BigLake) → biglake config → review
    biglakeConfigThenReview,
    // next[4]: existing AWS connector (Iceberg) → iceberg config → review
    icebergConfigThenReview,
    // next[5]: new AWS connector → create connector → iceberg config → review
    {
      id: 'inline_add_connector_iceberg',
      Component: InlineAddConnectorStep,
      nonReturnable: true,
      next: [icebergConfigThenReview],
    },
  ],
};
